module.exports = __webpack_public_path__ + "img/accessory_active.5caa5ded.svg";